"use client";

import * as stylex from "@stylexjs/stylex";
import { createContext, useContext } from "react";
import { useMokaMatch } from "@/hooks/use-moka-match";
import { sharedStyles } from "@/shared-styles";
const MokaMatchContext = createContext(null);
const useMokaMatchContext = () => {
  const mokaMatchContextValue = useContext(MokaMatchContext);
  if (!mokaMatchContextValue) {
    throw new Error("useMokaMatchContext must be used within MokaMatchRoot.");
  }
  return mokaMatchContextValue;
};
const MokaMatchRoot = ({
  children
}) => {
  const mokaMatchContextValue = useMokaMatch();
  return <MokaMatchContext value={mokaMatchContextValue}>
      <section aria-label="Play Moka" className="x1b58sdr">
        <div {...stylex.props(sharedStyles.stackTight)}>{children}</div>
      </section>
    </MokaMatchContext>;
};
MokaMatchRoot.displayName = "MokaMatchRoot";
export { MokaMatchRoot, useMokaMatchContext };